// @ts-nocheck
import { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { RootState } from 'src/store/reducers';

import PageLayout from '@components/PageLayout';
import EmailInbox from '@components/my-profile/inbox/EmailInbox';
import PhoneNumberInbox from '@components/my-profile/inbox/PhoneNumberInbox';

import * as actions from '@redux-actions/';

import { getPersonalDetails, createSubscription } from '@services/myProfileServices';
import { getUserSettings } from '@services/myProfileServices';

import { getLabelFallback } from '@utils/utils';

const Inbox = (): JSX.Element => {
    const inboxPageTitle = getLabelFallback('INBOX_PAGE_TITLE');
    const inboxPageTitleInside = getLabelFallback('INBOX_PAGE_TITLE_INSIDE');
    const inboxBackLabel = getLabelFallback('INBOX_BACK_CTA_LABEL');
    const config = useSelector((state: RootState) => state.common.config);
    const personalDetails = useSelector((state: RootState) => state.myProfile.personalDetails);
    const userSettings = useSelector((state: RootState) => state.myProfile.userSettings);
    const userSubscriptionEmail = useSelector((state: RootState) => state.myProfile.userSubscriptionEmail);
    const userSubscriptionPhone = useSelector((state: RootState) => state.myProfile.userSubscriptionPhone);
    
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getPersonalDetails(config.mockRequest, config.storeId));
        dispatch(getUserSettings(config.mockRequest, config.storeId));
        return () => {
            dispatch(actions.getPersonalDetailsSuccess(null));
        };
    }, []);

    useEffect(() => {
        if (userSubscriptionEmail !== null || userSubscriptionPhone !== null) {
            const createSubscriptionPayload: CreateSubscriptionPayload = {
                isMockRequest: config.mockRequest,
                storeId: config.storeId,
                catalogId: config.catalogId,
                langId: config.langId,
                errorViewName: 'ContactInformation',
                URL: 'ContactInformation',
                logonId: `${config.storeId}|${userSettings.subscription.email}`,
                formName: 'EmailPreferencesForm',
                receiveEmail: userSubscriptionEmail !== null ? userSubscriptionEmail : userSettings.subscription.isUserSubscribedByEmail,
                isResetPasswordRequest: true,
                optInEmail: userSettings.subscription.email,
                receiveEmail_CheckBox: "on",
                countrySelect: "US",
            };
            if(!!personalDetails?.phone1) {
                createSubscriptionPayload.receiveMobile = userSubscriptionPhone !== null ? userSubscriptionPhone : userSettings.subscription.isUserSubscribedByPhone
            }
            dispatch(createSubscription(createSubscriptionPayload));
        }
    }, [userSubscriptionEmail, userSubscriptionPhone]);

    return (
        <PageLayout
            data_element_id="AccountSummary_Inbox"
            hideMenu
            labelMenu={inboxPageTitle}
            backLabel={inboxBackLabel}
        >
            <div className="inbox">
                <div role="region" aria-label="Page title" className="primary-title">
                    {inboxPageTitleInside}
                </div>
                {!!personalDetails?.email && 
                    <EmailInbox email={personalDetails?.email} />
                }
                {!!personalDetails?.phone1 &&
                    <PhoneNumberInbox phone1={personalDetails?.phone1} />
                }
            </div>
        </PageLayout>
    );
};

export default Inbox;
